import { Temporal } from "temporal-polyfill"
import type { ApiSchema } from "vue-utils"

import Duration = Temporal.Duration
import Instant = Temporal.Instant
import Now = Temporal.Now
import PlainDate = Temporal.PlainDate
import PlainDateTime = Temporal.PlainDateTime
import PlainMonthDay = Temporal.PlainMonthDay
import PlainTime = Temporal.PlainTime
import PlainYearMonth = Temporal.PlainYearMonth
import ZonedDateTime = Temporal.ZonedDateTime

export {
	Duration,
	Instant,
	Now,
	PlainDate,
	PlainDateTime,
	PlainMonthDay,
	PlainTime,
	PlainYearMonth,
	Temporal,
	ZonedDateTime,
}

export const DurationSchema: ApiSchema<Duration> = (str) => Duration.from(str)
export const InstantSchema: ApiSchema<Instant> = (str) => Instant.from(str)
export const PlainDateSchema: ApiSchema<PlainDate> = (str) => PlainDate.from(str)
export const PlainTimeSchema: ApiSchema<PlainTime> = (str) => PlainTime.from(str)
export const PlainDateTimeSchema: ApiSchema<PlainDateTime> = (str) => PlainDateTime.from(str)
export const ZonedDateTimeSchema: ApiSchema<ZonedDateTime> = (str) => ZonedDateTime.from(str)
